import moment from 'moment-timezone';

const Utils = {
    getParenthesisDataFromResponse: (index) => (response) => {
        const strWithParenthesis = (response.match(/\(([^()]+)\)/g ))[index];
        const strWithinParenthesis = strWithParenthesis.replace('(', '').replace(')', '');
        return strWithinParenthesis.split('; ');
    },
    formatOperatingSystemName: (opSys) => {
        if ( opSys.includes('CPU iPhone OS') ) {
            return opSys.replace('CPU ', '').replace(' like Mac OS X', '')
        }
        return opSys;
    },
};

export const ValueGetters = {
    opSysFromResponse: (params) => {
        const {device} = params.data ?? {};
        if (device) {
            // eslint-disable-next-line
            const [deviceId, opSys] = Utils.getParenthesisDataFromResponse(0)(device);
            return Utils.formatOperatingSystemName(opSys);
        } else {
            return 'N/A';
        }
    },
    orientation: (params) => {
        const {innerHeight, innerWidth} = params.data ?? {};
        if (innerHeight > innerWidth) {
            return 'Portrait';
        } else if (innerHeight < innerWidth) {
            return 'Landscape';
        } else {
            return 'Square';
        }
    },
    sourceIpToLocation: (field) => (params) => {
        if (params.data?.source && params.context) {
            return (params.context.ipLocationMap.get(params.data.source) ? params.context.ipLocationMap.get(params.data.source)[field] : null) ?? params.data.source;
        } else {
            return '';
        }
    },
    isPresentValueFormatter: (params) => {
        if (params.data && params.data[params.colDef.field]) {
            return '✓';
        } else {
            return '';
        }
    },
    timeSpent: (params) => {
        return Math.ceil(params.data[params.colDef.field] / 1000)
    },
    simplifiedBrowser: (params) => {
        const strData = params.data.device?.split(') ')[2] ?? '';
        if (typeof strData === 'string') {
            return `
                ${strData.includes('Instagram') ? 'Instagram' : ''} 
                ${strData.includes('FB') ? 'Facebook' : ''} 
                ${strData.includes('CriOS') ? 'Chrome' : ''} 
                `;
        } else {
            return strData;
        }
    },
    newYorkTimeValueGetter: (param) => {
        return moment(param.data.date).tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
    },
    newYorkTimeValueFormatter: (param) => {
        return moment(param.data.date).tz('America/New_York').format('MMMM DD, YYYY hh:mm a');
    },
};